var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('BoothList',{staticStyle:{"margin-top":"32px"}}),_c('div',{staticClass:"container d-flex justify-content-center",staticStyle:{"margin-bottom":"32px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }